<template lang="html">
  <b-container>
    <b-row>
      <b-col>
        <h1>Importer ✨</h1>
        <div v-show="processingUpload">
          <h3>Processing upload ... <v-icon name="circle-notch" spin /></h3>
        </div>
        <ZipImport
          v-if="show_bound && importer_type == 'zip'"
          :key="'importer_zip_' + id"
          :show="show"
        />
        <ProjectImport
          v-if="show_bound && importer_type == 'project'"
          :key="'importer_project_' + id"
          :show="show"
        />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import ZipImport from "@/components/showImportAsZip/ZipImport.vue";
import ProjectImport from "@/components/showImportAsZip/ProjectImport.vue";
import { db } from "@/fstore";

export default {
  name: "ShowImport",
  components: {
    ZipImport,
    ProjectImport
  },
  data() {
    return {
      show: {},
      unbindFunction: null,
      show_bound: false,
      processingUpload: false
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    importer_type() {
      if (this.$route.meta.zip) {
        return "zip";
      }
      return "project";
    }
  },
  beforeDestroy() {
    // Unbind anything left.
    this.show_bound = false;
    this.unbindFunction();
  },
  beforeRouteLeave(to, from, next) {
    console.log(to, from, next);
    if (!this.processingUpload) {
      next();
    }
  },
  mounted() {
    console.log("EditorImportUploader", this.id);

    var _v = this;
    _v.unbindFunction = db
      .collection("editor_shows")
      .doc(_v.id)
      .onSnapshot(
        function(doc) {
          console.log("Current data: ", doc.data());
          _v.show = doc.data();
          _v.show_bound = true;
        },
        function(error) {
          console.log(error);
        }
      );
  },
  methods: {}
};
</script>

<style lang="css" scoped></style>
